import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';
import MissionReport from 'components/missionReport';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';
import esHandsOutUpClose from '../../images/characters/esmeralda_hands_out_up_close.png';
import esGooberGoofySmile from '../../images/characters/esmeralda_goober_goofy_smile.png';
import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import esGooberProud from '../../images/characters/esmeralda_goober_proud.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel3_en from './level3_operationDarkroom.md';
import markdownFileLevel3_fr_CA from './level3_operationDarkroom.fr_CA.md';
import markdownFileLevel4_en from './level4_operationShowerPower.md';
import markdownFileLevel4_fr_CA from './level4_operationShowerPower.fr_CA.md';
import markdownFileLevel5_en from './level5_operationKeepCarCool.md';
import markdownFileLevel5_fr_CA from './level5_operationKeepCarCool.fr_CA.md';
import markdownFileLevel6_en from './level6_operationGoCarFree.md';
import markdownFileLevel6_fr_CA from './level6_operationGoCarFree.fr_CA.md';

import imgLevel2Start from '../../images/level-2_start.png';
import imgLevel3Start from '../../images/level-3_start.png';
import imgLevel4Start from '../../images/level-4_start.png';
import imgLevel5Start from '../../images/level-5_start.png';

const markdownFileLevel3 = i18nData({
  en: new MarkdownScript(markdownFileLevel3_en),
  fr_CA: new MarkdownScript(markdownFileLevel3_fr_CA)
});
const markdownFileLevel4 = i18nData({
  en: new MarkdownScript(markdownFileLevel4_en),
  fr_CA: new MarkdownScript(markdownFileLevel4_fr_CA)
});
const markdownFileLevel5 = i18nData({
  en: new MarkdownScript(markdownFileLevel5_en),
  fr_CA: new MarkdownScript(markdownFileLevel5_fr_CA)
});
const markdownFileLevel6 = i18nData({
  en: new MarkdownScript(markdownFileLevel6_en),
  fr_CA: new MarkdownScript(markdownFileLevel6_fr_CA)
});

const levels = {
  '2': { img: imgLevel2Start },
  '3': { md: markdownFileLevel3, img: imgLevel3Start },
  '4': { md: markdownFileLevel4, img: imgLevel4Start },
  '5': { md: markdownFileLevel5, img: imgLevel5Start },
  '6': { md: markdownFileLevel6 }
};

export function preloadMissionReport () {
  preloader([
    esHandsOutWehey,
    esHandsOutUpClose,
    esGooberGoofySmile,
    ianHeadshotSmile,
    esGooberProud,
    imgLevel2Start,
    imgLevel3Start,
    imgLevel4Start,
    imgLevel5Start
  ]);
}

function missionReportSection ({ level, regionData, i18n: _ }) {
  const md = _(levels[level].md);
  const missionReportQuestions = md.getQuestions('Questions', 'Content', regionData);
  return (
    <Section id="mission-report">

      {/* Sara and Ian introduce mission report */}
      {videoSlide({
        id: 'video',
        youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData),
        notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData)
      })}

      {/* Scoring levels 2, 4 & 6 */}
      { (level === 2 || level === 4 || level === 6) &&
        balloonSlide({
          id: 'scoring',
          characterSide: 'left',
          characterImage: esHandsOutWehey,
          html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
        })
      }

      {/* Scoring levels 3 & 5 */}
      { (level === 3 || level === 5) &&
        balloonSlide({
          id: 'scoring',
          characterSide: 'right',
          characterImage: esHandsOutUpClose,
          html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData)
        })
      }

      {/* Instructions levels 2, 4 & 6 */}
      { (level === 2 || level === 4 || level === 6) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: esHandsOutUpClose,
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
        })
      }

      {/* Instructions 3 & 5 */}
      { (level === 3 || level === 5) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'left',
          characterImage: esHandsOutWehey,
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData)
        })
      }

      {/* Mission Reporting Screen */}
      <Slide
          id="report"
          bgColor="black"
          missionReportQuestions={missionReportQuestions}>
        <div
            className={'ui-slide mission-report-level-' + (level - 1)}>
          <header
              className="level-header">
            <figure className="level-header-thumb"><img src={levels[level - 1].img}/></figure>
            <Heading size={2}>
              {_('Mission Report:')}<br/>
              {md.getSectionMetadata('Mission Report', 'Title', regionData)}
            </Heading>
          </header>
          <section
              className="mission-report-form">
            <MissionReport missionReportQuestions={missionReportQuestions} />
          </section>
        </div>
      </Slide>

      {/* Impact screen for levels 2,4 & 6 */}
      { (level === 2 || level === 4 || level === 6) &&
        balloonSlide({
          id: 'impact',
          characterSide: 'right',
          characterImage: esGooberProud,
          html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
        })
      }

      {/* Impact screen for levels 3 & 5 */}
      { (level === 3 || level === 5) &&
        balloonSlide({
          id: 'impact',
          characterSide: 'right',
          characterImage: esGooberGoofySmile,
          html: md.getSubSectionAsHtml('Impact', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Impact', 'Notes', false, regionData)
        })
      }

      {/* Class Discussion */}
      {balloonSlide({
        id: 'class-discussion',
        characterSide: 'left',
        characterImage: ianHeadshotSmile,
        html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData)
      })}

    </Section>
  );
}

export default missionReportSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/11_missionReport/missionReportSection.jsx